module.exports = __webpack_public_path__ + "components/flag/static/square/td-f6a19b23d937fb7a30c6e80f22ca7da9.svg";